export default {
    "Success": true,
    "htmlMessage": null,
    "Data": [
        {
            "projectId": "e71fc372-170e-4bcb-b13b-d803756b3e4f",
            "projectName": "Data",
            "workItemType": "DPM Backlog Item",
            "states": [
                        "New",
                        "Committed",
                        "Design In Progress",
                        "Ready for Development",
                        "Dev in Progress",
                        "Waiting for RnD",
                        "Waiting for Redesign",
                        "Ready for Testing – UAT",
                        "Ready for Testing – Data",
                        "Testing in Progress (UAT)",
                        "Testing in Progress (Data)",
                        "Ready for Prod",
                        "On Hold",
                        "Done"
            ]
        },
        {
            "projectId": "e71fc372-170e-4bcb-b13b-d803756b3e4f",
            "projectName": "Data",
            "workItemType": "DE Backlog Item",
            "states": [
                        "New",
                        "Waiting for Re-design",
                        "Approved",
                        "Committed",
                        "Dev in Progress",
                        "Ready for Testing – Data",
                        "Testing in Progress (Data)",
                        "Ready for Testing – UAT",
                        "Testing in Progress (UAT)",
                        "Ready for Internal Review",
                        "Ready for Prod",
                        "Waiting for RnD",
                        "Prod – WIP",
                        "Done",
                        "Removed"

            ]
        },
        {
            "projectId": "e71fc372-170e-4bcb-b13b-d803756b3e4f",
            "projectName": "Data",
            "workItemType": "BI Developers Backlog Item",
            "states": [
                    "New",
                    "Draft",
                    "Approved",
                    "Committed",
                    "Discovery",
                    "Dev in Progress",
                    "On Hold",
                    "Ready for Internal Review",
                    "Ready for Testing – Data",
                    "Testing in Progress (Data)",
                    "Ready for Testing – UAT",
                    "Testing in Progress (UAT)",
                    "Pending for DL Tables",
                    "Pending for DWH Model",
                    "Waiting for RnD",
                    "Done",
                    "Removed"

            ]
        },
        {
            "projectId": "e71fc372-170e-4bcb-b13b-d803756b3e4f",
            "projectName": "Data",
            "workItemType": "Analytics Backlog Item",
            "states": [
                    "New",
                    "Committed",
                    "In Progress",
                    "In Review – Internal (Data)",
                    "In Review – External Teams",
                    "Ready for Prod",
                    "On Hold",
                    "Done",
                    "Removed"
            ]
        },
    ]
}